import { tableConstantsFactory } from './tableConstantsFactory';
const reportDocumentConstants = tableConstantsFactory('REPORTDOCUMENT');
reportDocumentConstants.RENDER_ANNOTATED_FAILURE = 'REPORTDOCUMENT_RENDER_ANNOTATED_FAILURE';
reportDocumentConstants.RENDER_ANNOTATED_SUCCESS = 'REPORTDOCUMENT_RENDER_ANNOTATED_SUCCESS';
reportDocumentConstants.CLEAR_DOWNLOAD_PATH = 'REPORTDOCUMENT_CLEAR_DOWNLOAD_PATH';
reportDocumentConstants.RENDER_FAILURE = 'REPORTDOCUMENT_RENDER_FAILURE';
reportDocumentConstants.RENDER_SUCCESS = 'REPORTDOCUMENT_RENDER_SUCCESS';
reportDocumentConstants.RESET = 'REPORTDOCUMENT_RESET';
export default reportDocumentConstants;